import React, { useState, useEffect } from 'react';
import './admin.css';
import { FiMoreVertical } from 'react-icons/fi';
import axios from 'axios';
import API_BASE from "../api/api";

const ViewUser = () => {
  const [users, setUsers] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);

useEffect(() => {
  axios
    .get(`${API_BASE}/getuser.php`, {
      withCredentials: true
    })
    .then((res) => {

      if (res.data.status === "success") {
        setUsers(res.data.data);
      } else {
        console.warn(res.data.message);
      }

    })
    .catch((err) => {
      console.error('Error fetching users:', err);
    });
}, []);

  const toggleMenu = (id) => {
    setOpenMenu(openMenu === id ? null : id);
  };

  return (
    <div className="viewbook-container">
  <h1 className="dashboard-title">All Users</h1>
      <div className="table-wrapper">
        <table className="book-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th> {/* ✅ Added */}
            </tr>
          </thead>
          <tbody>
            {users.length > 0 ? (
              users.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.phone}</td> {/* ✅ Added */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No users available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewUser;
